import React, { useEffect, useState } from 'react';
import PaginationOptions, { Page } from '../../../../api/ui/paginationOptions';
import useTranslation from '../../../../hooks/useTranslation';
import { useDispatch } from 'react-redux';
import { DEFAULT_END_AT, DEFAULT_START_AT } from '../../constants';
import { Helmet } from 'react-helmet';
import Visible from '../../../../components/Custom/Visible';
import PaginationComponent from '../../../../components/Custom/PaginationComponent';
import BOTable from '../../../../components/Tables/BOTable';
import Notification from '../../../../components/Notification/Notification';
import { storedPowerLogListRequest } from '../../../../redux/actions/log/storedPowerLogActions';
import useSchemaStoredPowerLog from '../../../../schema/table-schema/useSchemaStoredPowerLog';
import {UIConstants} from "../../../../constants/UIConstants";
import {
    SearchBtnContainer,
    SearchContainer, SearchContent,
    SearchDateRange,
    SearchLabel,
    SearchRow
} from "../../../../components/Search/searchSection";

function StoredPowerLogMain() {
  // -- component const --//
  // 페이지 제목
  const title = "admin.log.perplay.storedPower.title" // "NFT 파워 저장소 로그";
  const OPTION_KEY = Page.LOG_PERPLAY_STORED_POWER;

  const { t } = useTranslation();
  const { schema } = useSchemaStoredPowerLog();

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [tBody, setTbody] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 페이지 옵션
  const [pageOption, setPageOption] = useState();
  const [pageLength, setPageLength] = useState(25);
  const [page, setPage] = useState(1);

  const [startAt, setStartAt] = useState(DEFAULT_START_AT);
  const [endAt, setEndAt] = useState(DEFAULT_END_AT);

  // 로딩
  const [isLoading, setIsLoading] = useState(false);

  // 검색
  const [accountNo, setAccountNo] = useState(0);
  const [nftUid, setNftUid] = useState(0);
  const [isReset, setIsReset] = useState(false);

  // -- func & handler --//
  const fetchList = () => {
    setIsLoading(true);

    dispatch(
      storedPowerLogListRequest({
        page: page,
        pageLength: Number(pageLength),
        beginDate: startAt,
        endDate: endAt,
        accountNo: accountNo,
        nftUid: nftUid,
        callback: (data) => {
          console.log(data);
          setIsLoading(false);
          setTbody(data?.list);
          setTotalCount(data?.totalCount);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
          setIsLoading(false);
        },
      }),
    );
  };

  const handlePageChange = (_, value) => {
    setPage(Number(value));
  };

  const handlePageLengthChange = (value) => {
    setPageLength(value);
    setPage(1);
  };

  const handleSearchClick = () => {
    if (page === 1) {
      fetchList();
      return;
    }

    setPage(1);
  };


  const handleResetClick = () => {
      setAccountNo(0);
      setNftUid(0);
      setIsReset(true);
  }

  // -- react hooks --//
  useEffect(() => {
    PaginationOptions.getInstance().then((instance) => {
      const option = instance?.getData(OPTION_KEY);
      setPageOption(option);

      if (option.list_count_elements?.length > 0) {
        setPageLength(Number(25));
      }
    });
  }, [OPTION_KEY]);

  useEffect(() => {
    fetchList();
  }, [page, pageLength]);

  useEffect(() => {
      if(isReset) {
          setIsReset(false);
          fetchList();
      }
  }, [isReset]);

  // -- render --//
  return (
    <div className="page">
      <Helmet>
        <title>{t(title)}</title>
      </Helmet>

      <div className="topSection">
          <div className="leftSection">
              <p className="titleText">{t(title)}</p>
          </div>
      </div>

      <div className="spaceDiv10"/>

        <section>
            <SearchContainer>
                <SearchRow>
                    <SearchLabel text={UIConstants.Date}/>
                    <SearchDateRange
                        startAt={startAt}
                        endAt={endAt}
                        setStartAt={setStartAt}
                        setEndAt={setEndAt}
                    />
                </SearchRow>

                <SearchRow>
                    <SearchLabel text={UIConstants.UserId}/>
                    <SearchContent>
                        <input
                            className=""
                            value={accountNo || ""}
                            placeholder={UIConstants.UserId}
                            onChange={(e) => {
                                setAccountNo(Number(e.target.value));
                            }}
                        />
                    </SearchContent>

                    <SearchLabel text={UIConstants.NftUid}/>
                    <SearchContent>
                        <input
                            className=""
                            value={nftUid || ""}
                            placeholder={UIConstants.NftUid}
                            onChange={(e) => {
                                setNftUid(Number(e.target.value));
                            }}
                        />
                    </SearchContent>
                </SearchRow>
            </SearchContainer>

            <SearchBtnContainer
                handleSearchClick={handleSearchClick}
                handleResetClick={handleResetClick}
            />
        </section>

      <div className="spaceDiv10"/>

      <Visible Visible visible={pageOption?.top_paging}>
        <PaginationComponent
          disable={false}
          option={pageOption}
          page={page}
          pageLength={pageLength}
          totalCount={totalCount}
          onChange={handlePageChange}
          onSelect={handlePageLengthChange}
        />

        <div className="spaceDiv10"/>
      </Visible>

      <div className="spaceDiv10"/>

      <BOTable
        schema={schema}
        rows={tBody}
        loading={isLoading}
        onClick={null}
      />

      <div className="spaceDiv10"/>

      <Visible Visible visible={pageOption?.bottom_paging}>
        <PaginationComponent
          disable={false}
          option={pageOption}
          page={page}
          pageLength={pageLength}
          totalCount={totalCount}
          onChange={handlePageChange}
          onSelect={handlePageLengthChange}
        />
      </Visible>

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}
    </div>
  );
}

export default StoredPowerLogMain;
